'use client';

import FaIcon, { faLink, faXTwitter } from '@/components/icon/FaIcon/FaIcon';
import { copyToClipboard } from '@/utils/share';
import { SHARE_TWITTER_TEXT, createTwitterShareUrl } from '@/utils/snsShare';
import { useCallback } from 'react';
import styles from './ShareActionButtons.module.scss';

function ShareActionButtons({
  shareUrl,
  onShared,
  direction = 'row',
}: {
  shareUrl: string;
  onShared?: () => void | Promise<void>;
  direction?: 'row' | 'column';
}) {
  const handleCopyUrl = useCallback(async () => {
    const success = await copyToClipboard(shareUrl);
    if (success) {
      await onShared?.();
    }
  }, [shareUrl, onShared]);
  return (
    <div className={`${styles.container} ${styles[direction]}`}>
      <a
        href={createTwitterShareUrl(SHARE_TWITTER_TEXT, shareUrl)}
        className={styles.shareButtonLink}
        rel='noopener noreferrer nofollow'
        target='_blank'
      >
        <FaIcon icon={faXTwitter} />
        でシェア
      </a>
      <button type='button' className={styles.copyUrlButton} onClick={handleCopyUrl} aria-label='シェア用URLをコピー'>
        <FaIcon icon={faLink} />
        <span>
          URL<span className={styles.smallText}>を</span>コピー
        </span>
      </button>
    </div>
  );
}

export default ShareActionButtons;
